import { useEffect, useState } from "react";
import { TextField, Autocomplete, Checkbox, Chip } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { isEqual } from "lodash";

function MultiSelectAutocomplete({
  onChange,
  options,
  label,
  value,
  disablePortal = true,
  disableClearable = true,
  disableCloseOnSelect = true,
  additionalStyles = {},
  additionalTextFieldProps = {},
}) {
  const [selectedOptions, setSelectedOptions] = useState(value);

  useEffect(() => {
    setSelectedOptions(value);
  }, [value]);

  const onBlur = () => !isEqual(selectedOptions, value) && onChange(selectedOptions);

  return (
    <Autocomplete
      disablePortal={disablePortal}
      disableClearable={disableClearable}
      limitTags={3}
      disableCloseOnSelect={disableCloseOnSelect}
      id={`multi-select-auto-complete-${label}`}
      multiple
      getOptionLabel={(op) => op.label}
      value={selectedOptions}
      onBlur={onBlur}
      sx={{
        "span.MuiAutocomplete-tag": {
          background: "transparent",
          color: "#000",
          fontWeight: 600,
        },
        "& .MuiInputLabel-root": {
          lineHeight: "normal",
        },
        ...additionalStyles,
      }}
      onChange={(_, selectedValues) => setSelectedOptions(selectedValues)}
      isOptionEqualToValue={(option, _value) => option.id === _value.id}
      renderOption={(props, option, { selected }) =>
        option?.type === "customRender" ? (
          option?.render(selectedOptions)
        ) : (
          <li {...props}>
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option?.label}
          </li>
        )
      }
      options={options}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            variant="outlined"
            label={option?.label}
            {...getTagProps({ index })}
            onDelete={() => {
              const filters = value?.filter((item) => item.id !== option.id);
              onChange(filters);
            }}
          />
        ))
      }
      renderInput={(params) => (
        <TextField {...params} label={label} fullWidth {...additionalTextFieldProps} />
      )}
    />
  );
}

export default MultiSelectAutocomplete;
